/**
 * Shared geometry for the streaming flyout body.
 *
 * `FLYOUT_BODY_PAD` is the padding the host wraps each panel in;
 * `FLYOUT_BODY_BLEED` is the matching negative horizontal margin a full-width
 * sticky element (e.g. the Items pagination footer) uses to cancel that gutter
 * and read edge-to-edge. The two MUST stay in lockstep: the bleed cancels the
 * horizontal half of the pad, so a change to one is a change to the other.
 */
export const FLYOUT_BODY_PAD = "p-5";
/** The horizontal half of the pad, for a sticky bar that re-adds it after the bleed. */
export const FLYOUT_BODY_PAD_X = "px-5";
export const FLYOUT_BODY_BLEED = "-mx-5";
